import { IntlShape } from 'react-intl';
import { object as YupObject, string as YupString } from 'yup';

export const ValidationSchema = (formatMessage: IntlShape['formatMessage']) =>
  YupObject().shape({
    countryCode: YupString().trim(),
    mobile: YupString()
      .matches(/^[-\d().+]+( [-\d.]+)*$/, {
        message: formatMessage({
          id: 'form.validations.mobile.invalid',
        }),
      })
      .required(
        formatMessage({
          id: 'form.validations.mobile.required',
        })
      ),
  });
